module.exports = __webpack_public_path__ + "img/logo_white_w_colors.e5570548.png";